/* eslint-disable max-lines */
const moveMoneyStringsEN = {
  move: {
    title: 'Move Money',
    screenLabel: 'This is Move Money screen',
    transferHistoryTitle: 'Transfer History',
  },
  v2aDetourWeb: {
    title: 'Download the Varo app to use Varo to Anyone',
    subTitle: 'Varo to Anyone is only available in the Varo app.',
    ctaTitle: 'Get the Varo app',
    secondaryCTATitle: 'Close',
  },
  sender: {
    title: 'Send Money',
    sendMoneyLabel: 'Send Money',
    searchRecipients: 'Recipient Search',
    transferHistoryLabel: 'Transfer History',
    button: 'Next',
    minimumTransferLimit: 'Minimum transfer amount is $1.00',
    transferLimit: 'Your limit for this transfer is ',
    missingMaxTransferFallback: '$0.00',
    titleFirstPart: "You're about to send",
    titleMiddlePart: 'to',
    confirmButton: 'Confirm',
    cancelButton: 'Cancel',
    termsAndConditions: 'Varo Terms and conditions.',
    to: 'To:',
    forNoteTitle: 'For: ',
    forNotePlaceholder: 'Add a note',
    contactFetchError: 'An unknown error occurred while fetching the contacts.',
    v2aDisabled: 'V2A is Disabled',
    okay: 'Okay',
    v2aDisabledTitle: 'Varo to Anyone isn’t available right now',
    v2aDisableMessage: 'We’re working on it. Please try again later.',
    v2aTransfer: {
      title: 'Varo to Anyone',
      confirmationText:
        "Protect yourself from scams. Only send money to recipients you know and trust. Once they accept, the money can't be refunded. ",
      addNickname: 'Add nickname',
      learnMore: 'Learn more.',
    },
    transferHistory: {
      title: 'V2A Transfer history',
    },
    multipleContacts: {
      title: 'Where do you want to send the money?',
      selectButton: 'Select',
    },
    transferDetails: {
      title: 'Transfer details',
      cancelTransaction: 'Cancel transaction',
      cancelConfirmationText: 'Do you want to cancel this transaction?',
      yes: 'Yes',
      no: 'No',
      cancelTransactionSuccess: 'Transaction Cancelled.',
      cancelTransactionFailed: 'Transaction cancellation failed.',
      retry: 'Retry',
    },
    education: {
      heroText: 'Send Money To Anyone',
      title: 'Varo To Anyone',
      description: 'All you need is their phone number or email.',
      action: 'Next',
    },
    recipients: {
      errorFetchingContacts: 'Error in fetching contacts',
      contactAccessBannerMessage:
        'Add your contacts to send money to anyone instantly.',
      contactAccessBannerAction: 'Allow access to contacts',
      topRecipients: 'Top recipients',
      newRecipients: 'New recipient',
      allRecipients: 'All contacts',
      searchTitle: 'To',
      searchBarPlaceHolder: 'Enter name, email, or phone',
      noRecipientsFoundPrefix: 'To send money to someone new, enter their ',
      noRecipientsFoundEmailAddress: 'email address',
      noRecipientsFoundOr: ' or ',
      noRecipientsFoundPhoneNumber: 'US phone number.',
    },
    transferSuccess: {
      headerTitle: ' SENT',
      successTitle: 'You successfully sent $10.00 to Nicola for McDonalds',
      educationMessage:
        "If Nicola doesn't accept the fund in 14 days, we will refund you. You\ncan always cancel the transaction from the transaction history",
      ctaTitle: 'Done',
    },
    promoScreen: {
      title: "YOU CAN ALSO SEND MONEY TO FRIENDS WHO DON'T HAVE VARO",
      body: 'Just enter their phone number or email the next time you send money.',
      ctaTitle: 'Got it!',
    },
  },
  receiverLanding: {
    header: {
      title: '{{name}} sent you {{amount}}',
      line: 'Join {{name}} at Varo and get your money instantly. Signup is safe, fast, and easy.*',
      button: 'Receive with Varo',
      inlineAlert:
        'Get up to $300 during your first 6 months at Varo when you sign up from this page.',
      incentiveAlert:
        'Get $25 when you sign up from this page and spend $20 within 30 days of account opening. It`s that easy.',
      bullets: {
        title: 'Join Varo for a more convenient way to bank',
        items: [
          'Work your way up to $1,000 over time with direct deposit at Varo.¹',
          'Build credit the easy way. Quals apply.²',
          'Get paid up to 2 days early.³',
        ],
      },
      secondaryCTA: 'Not now, transfer to a different bank',
    },
    marketing: {
      title: 'your best money life starts here',
      benefits: [
        {
          title: 'No hidden fees. Period.',
          subtitle: 'Loans and optional services have fees.',
        },
        {
          title: '{{elevatedApy}} Annual Percentage Yield.',
          subtitle:
            'Reach your saving goals sooner up to {{compactBalanceCap}}. Quals apply.⁴',
        },
        {
          title: 'FDIC Insured.',
          subtitle: 'Your money is safe with us.',
        },
      ],
      loveVaro: {
        title: 'See why PEOPLE LOVE VARO',
        iosScore: '4.9',
        iosReviews: '171k App Store Reviews',
        androidScore: '4.7',
        androidReviews: '201k Google Play Reviews',
      },
      termsAndCondition: 'Terms & Conditions',
      privacyPolicy: 'Privacy Policy',
      legalDocuments: 'Legal Documents',
      varoCopyrightLabel: 'Varo Bank © {{year}}\nMember FDIC',
    },
  },
  errorMsg: {
    invalidCard: {
      error:
        'This card cannot be used for this transfer. Please retry with a different card.',
    },
    invalidCvv: {
      error: 'The CVV is invalid',
    },
    invalidZip: {
      error: 'The ZIP code is incorrect',
    },
    invalidExpiry: {
      error: 'The Expiration Date is incorrect',
    },
    retryLaterError: {
      error: 'We couldn’t process your payment.',
      subtitle: 'Please retry later.',
    },
    illegalState: {
      error: 'We are unable to process this request.',
      subtitle: 'Please contact the sender to request a new link.',
    },
    terminalError: {
      error: 'We’re processing your transfer.',
      subtitle:
        "You’ll receive a notification via sms/email once it's complete.",
    },
    badToken: {
      error: 'Something went wrong.',
      subtitle:
        'This payment is invalid or has already expired.\nPlease contact the sender directly to request a new link.',
    },
    riskReviewError: {
      error: 'This transfer is currently on hold.',
      subtitle:
        'We need to verify some information before we can process this transaction.',
    },
    unknownError: {
      error: 'Something went wrong.',
    },
  },
  transferStrings: {
    title: 'Transfer',
    fundInstantlyTitle: 'Fund instantly',
    from: 'From:',
    to: 'To:',
    selectAnAccount: 'Select an account',
    amount: 'Amount',
    transferLimit: 'Your limit for this transfer is ',
    button: 'Next',
    transferFrom: 'Transfer from',
    paymentFrom: 'Payment from',
    externalAccounts: 'External Accounts',
    varoAccounts: 'Varo Accounts',
    linkADebitCard: 'Link a debit card',
    linkAnAccount: 'Link an account',
    externalDebitCards: 'External Debit Card',
    linkAccountError:
      'We couldn’t start linking your account. Please try again.',
    linkAccountFailed:
      'We couldn’t finish linking your account. Please try again.',
    relinkAccountError:
      'We couldn’t start relinking your account. Please try again.',
    relinkAccountFailed:
      'We couldn’t finish relinking your account. Please try again.',
    successSubText: 'Your transfer has been processed.',
    successTitle: '\n Transferred',
    doneButton: 'Done',
    secondaryButton: 'See my transfers',
    errorText: 'We couldn’t process your transfer',
    errorSubText: 'Something went wrong, please try again.',
    tryAgainButton: 'Try again',
    errorButton: 'I’ll try later',
    available: 'Available:',
    movedToBelieveInstantly: 'Moved to Believe instantly',
    confirmTitle: 'Confirm your transfer',
    arrives: 'Arrives',
    arriveText: 'Your money will transfer immediately.',
    confirmText:
      'By tapping “Confirm”, I authorize Varo Bank to make a one-time ACH withdrawal of {{amount}} from {{sourceAccountName}} account to transfer to my {{destinationAccountName}} today {{date}}. I understand that the transaction complies with all applicable laws. This transfer will be made and there is no option to cancel.',
    confirmButton: 'Confirm',
    transferTo: 'Transfer to',
    eyebrowText: 'Success',
    cancelButton: 'Cancel',
    currency: '$',
    closeButton: 'Close',
    limits: 'Limits',
    addMoney: 'Add money',
    infoIconLabel: 'Info',
    amountRequired: 'Required',
    maxLimitError: 'The maximum you can transfer is {{maxAmount}}',
    minLimitError: 'The minimum you can transfer is {{minAmount}}',
    instantNoFee: 'Instant',
    bottomSheet: {
      title: 'Your linked debit card is expired',
      subTitle: 'Verify your card details now in order to move money.',
      updateButton: 'Update expiration date',
      closeButton: 'Close',
    },
  },
  findAtm: {
    header: 'No-fee ATMs near you',
    openInMaps: 'Open in Maps',
    requestLocationTitle: 'We need your location to find no-fee ATMs nearby.',
    requestLocationBody:
      'Turn on location services in your device settings. You can also search for ATMs by entering an address or ZIP code.',
    copied: 'Copied!',
  },
  depositCash: {
    disclaimerTextExtended: {
      footnoteAvailability:
        '¹Availability to add cash with a barcode varies by location.',
      footnoteCVS:
        '²Available at all stand-alone CVS locations with a cashier in the US except those located within hospitals, on military bases, or in Target. You can add between $20-$500 per transaction. A retail service fee up to $4.95 and limits may apply for adding cash at other retail locations. ©Copyright 2026 ',
      url: 'CVS.com.',
      footnoteBrands:
        '© 2026 7-Eleven, Inc. All rights reserved. 7-Eleven is a registered trademark of 7-Eleven.',
      footnoteGreenDot:
        'Service provided by Green Dot®. ©2026 Green Dot Corporation. All rights reserved. Green Dot Corporation NMLS #914924; Green Dot Bank NMLS #908739.',
    },
    disclaimerTextKroger: {
      footnoteAvailability:
        '¹Availability to add cash with barcode varies by location.',
      footnoteCVS:
        '²Available at all stand-alone CVS location with a cashier in the US, except for locations on military bases, within hospitals, or inside Target. Adding cash via barcode is free at the Kroger Family of Stores (excluding Harris Teeter stores) and retail service fee of up to $4.95 may be charged for adding cash with card swipe. Transaction amounts must be between $20 and $500. Limits and a retail service fee of up to $4.95 may apply when adding cash at other retail locations. ©Copyright 2026 ',
      url: 'CVS.com.',
      footnoteBrands:
        '© 2026 7-Eleven, Inc. All rights reserved. 7-Eleven is a registered trademark of 7-Eleven.',
      footnoteGreenDot:
        'Service provided by Green Dot®. ©2026 Green Dot Corporation. All rights reserved. Green Dot Corporation NMLS #914924; Green Dot Bank NMLS #908739.',
    },
    header: 'Add cash',
    howToDepositFaq: 'FAQ',
    cvsPrimaryCopyExtended: 'Enjoy no fees at 7,500 CVS® locations²',
    cvsPrimaryCopyKroger:
      'Enjoy fee-free options at 7,500 CVS® and Kroger® locations²',
    cvsSecondaryCopyExtended: 'Add up to $1,500 daily.',
    feePrimaryCopy: 'Or add cash for a fee at other participating retailers',
    feeSecondaryCopy: 'Retail service fee up to $4.95 and limits may apply.',
    showDepositLocationsButton: 'Show locations',
    title: 'add cash at 90,000+ locations',
    subtitle:
      'Ask the cashier to scan your barcode¹ or swipe your Varo Debit Card.',
    copied: 'Copied!',
    maps: {
      openInMaps: 'Open in Maps',
      showBarcode: 'Show barcode',
      requestLocationTitle:
        'We need your location to find deposit locations nearby.',
      requestLocationBody:
        'Turn on location services in your device settings. You can also search for deposit locations by entering an address or ZIP code.',
      freeCashDepositLocations: 'No fee locations',
      noFee: 'No fee',
      retailerFee: 'Retailer fee: ${{fee}}',
      krogerFeeNote:
        'Use a barcode to add cash for no fee. Swiping your card may add a retail service fee of up to $4.95. Limits may apply.',
    },
    barcode: {
      defaultLocationName: 'Cash Deposit Location',
      defaultRetailerName: 'Cash Deposit Location',
      defaultRetailerAddress: 'Address not available',
      defaultDistance: '0.0 mi',
      openInMaps: 'Open in Maps',
      instructionTitle: 'Ask cashier to scan this barcode',
      downloadApp: {
        title: 'Download the app to add cash with your barcode',
        subtitle: 'You can only access your barcode in the Varo app.',
        backButton: 'Back',
      },
      loading: {
        spinnerMessage: 'Please wait, barcode is loading',
      },
      barcodeInfo:
        'Barcodes are location-specific. Limit one transaction per barcode.',
      depositLimits:
        'You can deposit between $20 and $500 at a time, depending on location. Deposit up to $1,500 daily and $5,000 monthly.',
      feesDisclaimer:
        'Retail service fee up to $4.95 and limits may apply. Keep the receipt as proof of your transaction.',
      limitText:
        'Barcodes are location-specific. Limit one transaction per barcode. You can add between $20 and $500 at a time, depending on location. Add up to $1,500 daily and $5,000 monthly.',
      disclaimerText:
        'Retail service fee up to $4.95 and limits may apply. Keep the receipt as proof of your transaction.',
      locationServices: {
        title: 'Turn on location services to view your barcode',
        subtitle: 'This helps protect your account.',
        enableButton: 'Turn on location services',
        backButton: 'Back',
      },
      barcodeError: {
        title: "This page isn't loading right now",
        subtitle: "We're working on it! Please try again later.",
        retryButton: 'Try again',
        backButton: 'Back',
      },
      barcodeExpired: 'Barcode expired',
      refreshBarcode: 'Refresh barcode',
      refreshFailedError: 'Barcode refresh failed. Please try again.',
      newBarcodeCreated: 'New barcode created',
      krogerFeeNote:
        'Use a barcode to add cash for no fee. Swiping your card may add a retail service fee of up to $4.95. Limits may apply.',
    },
  },
  paymentDetails: {
    header: 'Transfer {{amount}} to your bank account',
    inlineAlertText:
      'To securely transfer your {{amount}}, please enter your name, email and debit card information below. Varo uses advanced encryption and safety measures to protect your personal data.',
    firstName: 'First name',
    lastName: 'Last name',
    nameOnCard: 'Name on card',
    address: 'Card billing address',
    next: 'Next',
    closeButton: 'Close',
    email: 'Email',
    cardNumber: 'Debit card number',
    expDate: 'Expiration',
    cvv: 'CVV',
    zip: 'Zip Code',
    agreeTerms1: 'I have read and agree to ',
    agreeTerms2: ' and ',
    agreeTerms3: '.',
    agreeTermsLink: 'Varo to Anyone Terms and Conditions',
    agreePrivacyLink: 'Privacy Policy',
    agreeMarketing: 'I agree to receive marketing notifications.',
    button: 'Get {{amount}}',
    state: 'State',
    dateHint: 'MM/YY',
    newAddress: 'Add new address',
    tabapayScreen: {
      title: 'Add a debit card',
      back: 'Back',
    },
    tabaPayValidation: {
      securityCode: 'Security code',
    },
    errorMessage: {
      cancelTitle: 'You’re nearly there',
      cancelSubtitle: 'Only one step left to finish up.',
      timeOutTitle: 'Your session timed out',
      failureTitle: 'Your bank didn’t approve the request',
      errorTitle: 'Authentication failed',
      tryAgain: 'Try again.',
      retryButton: 'Retry',
      retryWithDifferentCard: 'Try again or use a different debit card.',
      continueButton: 'Continue',
      exitButton: 'Exit',
      addDifferentCard: 'Add a different card',
      threeDSErrorTitle: 'Something went wrong',
    },
  },
  address: {
    title: 'Enter your address',
    subTitle: 'Use the mailing address associated with your debit card.',
    textField: {
      addressLine1: 'Street address',
      addressLine2: 'Apt/Suite/Unit',
      city: 'City',
      state: 'State',
      zip: 'ZIP Code',
    },
    inlineError: 'Remove special characters ,”~^()I;',
    enterAddressManually: 'Enter address manually',
    buttons: {
      next: 'Next',
      editAddress: 'Edit address',
      done: 'Done',
    },
    validations: {
      suggested: 'Suggested',
      next: 'Next',
      whatYouEntered: 'What you entered',
      suggestedAddress: {
        header: 'We found a better address',
        subHeader: 'Review the suggested address below before proceeding.',
      },
      overRideAddress: {
        header: 'Confirm your address',
        subHeader:
          'Review the information below to make sure everything is correct.',
      },
      invalidAddress: {
        header: 'Double check your address',
        subHeader: '',
      },
    },
  },
  paymentConfirmation: {
    title: 'Transfer successful',
    button: 'Get Started',
    headline: '{{amount}} has been sent to your debit card.',
    subtitle1: 'Join Varo.',
    subtitle2: 'Get $25.',
    description:
      'Get $25 when you sign up and spend $20 within 30 days of account opening. It’s that easy.',
    benefit1: 'No monthly fees',
    benefit2: 'Early payday',
    benefit3: 'Instant cash advance',
    disclaimerText: 'To earn $20, you must sign up via this page.',
    disclaimerLink: 'See full terms',
    transferring: 'Transferring money',
  },
  transferHistory: {
    transferHistoryTitle: 'Transfer history',
    emptyStateButtonLabel: 'Transfer money',
    emptyStateHeadlineText: 'You haven’t initiated a transfer yet',
    emptyStateBodyText: 'Your transfers will appear here.',
    v2aTitle: 'V2A transfer history',
    v2aEmptyStateButtonLabel: 'Send money instantly',
    v2aEmptyStateHeadlineText: "You haven't sent a Varo to Anyone yet",
    v2aEmptyStateBodyText: 'Your transactions will appear here.',
    from: 'From: ',
    to: 'To: ',
    pendingStatus: 'Pending',
  },
  transferDetails: {
    headerTitle: 'Transfer detail',
    arrives: 'Arrives',
  },
  transactionHistoryBottomSheet: {
    history: 'Transfer history',
    mobileDeposit: 'Mobile deposit history',
    v2a: 'Varo to Anyone history',
  },
  compareOptions: {
    title: 'Move money details',
    learnMore: 'Learn More',
  },
  dcf: {
    title: 'Fund instantly',
    addMoney: 'Add money',
    done: 'Done',
    currency: '$',
    otherAmount: 'Other amount',
    other: 'Other',
    maxAmountMsg: 'You can transfer up to ',
    minAmountMsg: 'Add a minimum of ',
    errorText: 'Debit card transfer unavailable',
    errorSubText:
      "You've reached the max dollar amount or number of times you can transfer from debit card. Try again later",
    closeButton: 'Close',
    errorMessage: 'Something went wrong',
    errorSubMessage:
      "We're unable to process your request.Try again in a few minutes or with a different card",
    disclaimerMessage:
      "Your payment is secure and we don't store this card info.",
    successTitle: ' WAS ADDED TO YOUR BANK ACCOUNT',
    eyebrowText: 'SUCCESS',
    cardNumber: 'Card Number',
    invalidParams: 'Invalid Parameters',
    dcfAddress: {
      title: 'Debit card billing address',
      editAddressButton: 'Edit address',
    },
    tabapay: {
      title: 'How much would you like to transfer?',
      caption: 'Money will be available immediately.',
    },
    disclaimerInfo:
      'Your card information is stored securely and may be used for payments and transfers per your authorization.',
  },
  p2pDebit: {
    title: 'Fund your Varo account instantly from other apps',
    info: 'You can use apps like Venmo®, PayPal®, or Apple Cash® to fund your account. Use your Varo debit card or account and routing number.',
    expiration: 'Exp',
    cvv: 'CVV',
    error: 'No Cards Available',
    buttons: {
      okay: 'Okay',
    },
    numberCopied: 'Card number copied',
    accountNumber: 'Account number',
    routingNumber: 'Routing number',
    copyToClipBoard: 'Copied!',
  },
  zelle: {
    web: {
      title: 'Download the Varo app to use Zelle®',
      subtitle: 'Zelle® is only available in the Varo app.',
      description: 'Scan the QR code with your phone to get started.',
      getAppCta: 'Get the App',
      qrCodeLabel: 'QR code to download Varo app',
    },
    notSupportedTitle: 'Not supported on web',
    notSupportedBody: 'Zelle is only available on the mobile app.',
    notSupportedBackButton: 'Back',
    permissionPrompts: {
      contact: {
        title: 'We would like to access your phone contacts',
        message:
          'We only sync phone numbers and email addresses from your contact list to help you add and pay a new recipient in Zelle®.',
      },
      camera: {
        title: 'We would like to access your camera',
        message:
          'We only access your camera to help you add and pay a new recipient in Zelle®.',
      },
      gallery: {
        title: 'We would like to access your photos',
        message:
          'We only access your photos to help you add and pay a new recipient in Zelle®.',
      },
    },
    sdkLaunchError: {
      title: "This page isn't loading right now",
      subtitle: "We're working on it.",
      backButton: 'Back',
    },
    close: 'Close',
    help: 'Help',
  },
  zelleIneligible: {
    manageDirectDeposit: 'Manage direct deposit',
    error: {
      title: 'Something went wrong',
      body: 'We couldn\u2019t load Zelle eligibility information. Please try again later.',
      close: 'Close',
    },
  },
  zelleScamsWarning: {
    acceptAndContinue: 'Accept and continue',
  },
  zelleMulingWarning: {
    acceptAndContinue: 'Accept and continue',
  },
  zelleError: {
    back: 'Back',
  },
  verifyEmailCode: {
    header: 'Enter verification code',
    description:
      'Enter the code we sent to verify your email address {{email}}.',
    submit: 'Submit',
    buttons: {
      resend: 'Resend code',
    },
    alert: {
      title: 'Don’t share this code',
      body: 'A Varo customer representative will never ask for this code.',
    },
  },
  pinWheel: {
    error: {
      title: 'Something went wrong',
      body: 'Our automatic setup isn`t available right now. Try again later.',
      button: 'Okay',
    },
    buttons: {
      view: 'View form',
      later: 'Try later',
    },
    title: 'Use a direct deposit form instead',
    body: 'Send a prefilled direct deposit form to your employer or try again later',
  },
  debitCardAdded: {
    title: 'DEBIT CARD ADDED',
    content:
      'You’re debit card was successfully added and can be used to transfer money or make payments.',
    eyeBrowText: 'SUCCESS!',
    buttons: {
      next: 'Next',
    },
  },
  tabapayCardAdded: {
    title: 'You added A debit card',
    eyeBrowText: 'SUCCESS!',
    buttons: {
      next: 'Next',
    },
  },
  tabapayTransferSuccess: {
    title: ' AVAILABLE NOW',
    eyebrowText: 'SUCCESS',
    buttons: {
      next: 'Next',
    },
  },
  applePay: {
    title: 'Apple Pay',
    limits: 'Limits',
    addMoneyButton: 'Add money with Pay',
    maxAmountMsg: 'The maximum you can transfer is ',
    minAmountMsg: 'The minimum you can transfer is ',
    applePayAccessibilityLabel: 'Apple Pay',
    dailyTransactionLimitReached:
      "You've reached your transaction limit for today.",
    closeButton: 'Close',
    errorDone: 'Done',
    errorHeadline: 'Error',
    errorBody: 'An unexpected error occurred.',
    unavailable: {
      closeButton: 'Close',
      noDebitCard: {
        title: 'Apple Pay needs a debit card',
        body: 'Add a Visa or Mastercard debit card to your Apple Wallet to use Apple Pay for funding.',
      },
    },
  },
  applePaySuccess: {
    title: '{{amount}} AVAILABLE NOW',
    eyebrowText: 'SUCCESS',
    subtitle: 'Your money is now in your bank account.',
    buttons: {
      done: 'Done',
    },
  },
  googlePay: {
    title: 'Google Pay',
    limits: 'Limits',
    addMoneyButton: 'Add money with Google Pay',
    maxAmountMsg: 'The maximum you can transfer is ',
    minAmountMsg: 'The minimum you can transfer is ',
    dailyTransactionLimitReached:
      "You've reached your transaction limit for today.",
    closeButton: 'Close',
    errorDone: 'Done',
    errorHeadline: 'Error',
    errorBody: 'An unexpected error occurred.',
    unavailable: {
      closeButton: 'Close',
      noDebitCard: {
        title: 'Google Pay needs a debit card',
        body: 'Add a Visa or Mastercard debit card to your Google Wallet to use Google Pay for funding.',
      },
    },
  },
  googlePaySuccess: {
    title: '{{amount}} AVAILABLE NOW',
    eyebrowText: 'SUCCESS',
    subtitle: 'Your money is now in your bank account.',
    buttons: {
      done: 'Done',
    },
  },
};

export default moveMoneyStringsEN;
